module.exports = __webpack_public_path__ + "static/media/arrow-up.e1bc49a8.svg";